// BM-H82 P1-a - Client workbook schema mirror.
//
// This file mirrors the six sections, twenty-five questions, sensitive
// list, and evidence-required list from
// backend/hub/epr/workbook_schema.py. It exists so the client bundle
// can render without a round-trip to the schema endpoint. A pytest
// (backend/tests/test_bmh3971_epr_lifetime_transfers.py) asserts the two
// are in step, wording and help text included.
//
// BM-H3971: Q24 and Q25 (lifetime transfers, the solicitor's wording of
// 8 Oct 2026) were added as schema 1.1. Q1 to Q23 keep their numbers.

export const WORKBOOK_SCHEMA_VERSION = "1.1";

export const SENSITIVE_QUESTION_IDS = ["q3", "q9", "q10", "q11", "q21", "q22"];
export const EVIDENCE_REQUIRED_IDS = ["q4", "q6", "q12", "q14", "q16", "q17", "q18", "q20", "q21"];

export const SECTIONS = [
  { id: "s1", title: "Why now and what outcome matters", questions: ["q1", "q2", "q3"] },
  { id: "s2", title: "Existing documents and actual understanding", questions: ["q4", "q5", "q6", "q7"] },
  { id: "s3", title: "People and provision", questions: ["q8", "q9", "q10", "q11"] },
  { id: "s4", title: "Assets and structure", questions: ["q12", "q13", "q14", "q15", "q24", "q25", "q16", "q17", "q18"] },
  { id: "s5", title: "Cross-border and complex arrangements", questions: ["q19", "q20"] },
  { id: "s6", title: "Capacity, health and life events", questions: ["q21", "q22", "q23"] },
];

export const QUESTIONS = [
  { id: "q1", section: "s1", prompt: "What made you book this review now?" },
  { id: "q2", section: "s1", prompt: "At the end of this review, what would you most like to be clear about?" },
  { id: "q3", section: "s1", prompt: "Is there anything you would prefer to discuss privately at the appointment?" },
  { id: "q4", section: "s2", prompt: "Do you already have a Will, LPA or trust in place? If yes, please upload copies where you have them." },
  { id: "q5", section: "s2", prompt: "In your own words, what does your current Will (or your understanding of it) actually say?" },
  { id: "q6", section: "s2", prompt: "When did you last read your existing Will or LPA in full?" },
  { id: "q7", section: "s2", prompt: "Are there any documents you know exist but cannot locate?" },
  { id: "q8", section: "s3", prompt: "Who are the people who depend on you financially or emotionally?" },
  { id: "q9", section: "s3", prompt: "Is there anyone you would want to receive less than an equal share, or nothing at all?" },
  { id: "q10", section: "s3", prompt: "Are there any current or past disputes in the family we should know about?" },
  { id: "q11", section: "s3", prompt: "Has anyone encouraged, pressured or advised you to make particular choices in your Will?" },
  { id: "q12", section: "s4", prompt: "How is your home owned (sole, joint tenants, tenants in common)?" },
  { id: "q13", section: "s4", prompt: "Do you have investments, savings or life policies you would like listed?" },
  { id: "q14", section: "s4", prompt: "Have you been divorced, separated or in a civil partnership that has ended?" },
  { id: "q15", section: "s4", prompt: "Do you have any gifts made in the last seven years, or plans to make significant gifts?" },
  { id: "q16", section: "s4", prompt: "Do you have a pension, and have you made a nomination for it?" },
  { id: "q17", section: "s4", prompt: "If you have a pension, is the death benefit paid at the scheme's discretion?" },
  { id: "q18", section: "s4", prompt: "Do you own a business, shares in a private company, or a partnership interest?" },
  { id: "q19", section: "s5", prompt: "Do you have any assets or ties (including tax residence) outside England and Wales?" },
  { id: "q20", section: "s5", prompt: "Do you have a Will made under the law of another country?" },
  { id: "q21", section: "s6", prompt: "Do you have any health conditions or medications that we should be aware of when planning?" },
  { id: "q22", section: "s6", prompt: "Have you experienced a bereavement or major life event in the last two years?" },
  { id: "q23", section: "s6", prompt: "Do you need an interpreter, or any other adjustment, for the appointment itself?" },
  // BM-H3971: the solicitor's wording, character for character.
  { id: "q24", section: "s4", prompt: "In the last 14 years, have you transferred money or property into a trust during your lifetime, or added money or property to an existing trust?", help: "Do not include a trust created by your Will. Include transfers into settlements or trusts even if you or your family could benefit." },
  { id: "q25", section: "s4", prompt: "In the last 7 years, have you given away money or property, sold anything for less than its full value, or otherwise transferred value to another person?", help: "Include substantial gifts to family or friends. Do not try to decide whether a gift was exempt. Your fee earner will check that." },
];

export function isSensitive(qid) {
  return SENSITIVE_QUESTION_IDS.indexOf(qid) !== -1;
}

export function requiresEvidence(qid) {
  return EVIDENCE_REQUIRED_IDS.indexOf(qid) !== -1;
}

export function questionsForSection(sectionId) {
  const s = SECTIONS.find((x) => x.id === sectionId);
  if (!s) return [];
  return s.questions.map((qid) => QUESTIONS.find((q) => q.id === qid)).filter(Boolean);
}
